import { render, staticRenderFns } from "./paihaoliebiao.vue?vue&type=template&id=3f1ed85e&scoped=true&"
import script from "./paihaoliebiao.vue?vue&type=script&lang=js&"
export * from "./paihaoliebiao.vue?vue&type=script&lang=js&"
import style0 from "./paihaoliebiao.vue?vue&type=style&index=0&id=3f1ed85e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1ed85e",
  null
  
)

export default component.exports